<template>
  <div class="container-box">
    <div class="container-inner">
      <h2 class="title-type-1">
        광고주 수정
        <v-tooltip right content-class="tooltip-custom-1">
          <template v-slot:activator="{ on, attrs }">
            <v-icon class="ico-help-1" v-bind="attrs" v-on="on"
              >mdi-help</v-icon
            >
          </template>
          <span
            >카카오 VX 캠페인을 진행한 모든 광고주, 대행사, 카카오그룹 관리 메뉴
            입니다</span
          >
        </v-tooltip>
      </h2>
      <ul class="tab-type-1">
        <li>
          <a href="javascript:void(0);" class="active">광고주 정보</a>
        </li>
      </ul>
      <!-- advertiser name -->
      <h3 class="title-type-3">
        광고주 회사명
        <p class="form-coment-1 ml-2 mt-1">
          <v-icon>mdi-alert-circle-outline</v-icon>
          회사명은 변경이 불가합니다.
        </p>
      </h3>
      <div class="relative white rounded pa-6 pr-16 mb-8 text-md-body-1">
        {{ advertiserName }}
      </div>
      <!--// advertiser name -->
      <div class="form-wrap">
        <div class="form-group mb-8">
          <h3 class="title-type-3">
            광고주 분류
            <span class="required">
              <v-icon>mdi-check-circle-outline</v-icon>
              필수
            </span>
          </h3>
          <div class="relative white rounded pa-6 pr-16">
            <v-select
              :items="searchSel"
              :label="searchSelChoice"
              v-model="searchSelChoice"
              item-color="#000"
              class="input-custom-2"
              height="40px"
              solo
              required
            ></v-select>
          </div>
        </div>

        <div class="form-group mb-8">
          <h3 class="title-type-3">
            업종
            <span class="required">
              <v-icon>mdi-check-circle-outline</v-icon>
              필수
            </span>
          </h3>
          <div class="relative white rounded pa-6 pr-16">
            <v-select
              :items="searchSel2"
              :label="searchSelChoice2"
              v-model="searchSelChoice2"
              item-color="#000"
              class="input-custom-2"
              height="40px"
              solo
              required
            ></v-select>
          </div>
        </div>
        <div class="form-group mb-8">
          <h3 class="title-type-3">담당자 성명</h3>
          <div class="relative white rounded pa-6 pr-16">
            <v-text-field
              class="input-custom-2"
              type="text"
              height="40px"
              v-model="managerName"
              solo
            ></v-text-field>
          </div>
        </div>
        <div class="form-group mb-8">
          <h3 class="title-type-3">대표 이메일 주소</h3>
          <div class="relative white rounded pa-6 pr-16">
            <v-text-field
              class="input-custom-2"
              type="text"
              height="40px"
              v-model="advertiserEmail"
              :rules="eamilRules"
              solo
              hide-details="auto"
            ></v-text-field>
          </div>
        </div>
      </div>
      <div class="relative white rounded pa-6 pr-16">
        <div class="form-row-1">
          <p class="label">발급일</p>
          <div class="write-con">
            <span class="text-value" v-if="advertiserinfoInfo.create_at">
              {{
                advertiserinfoInfo.create_at | moment('YYYY.MM.DD(hh:mm:ss A)')
              }}
            </span>
          </div>
        </div>
        <div class="form-row-1">
          <p class="label">발급관리자</p>
          <div class="write-con">
            <span class="text-value">{{ creator.manager_name }}</span>
          </div>
        </div>
      </div>
      <div class="d-flex justify-space-between mt-10">
        <div>
          <v-btn
            large
            depressed
            dark
            max-height="40px"
            color="#ff5959"
            class="button-type-1"
            @click="changeDisable"
          >
            비활성화
          </v-btn>
        </div>
        <div>
          <v-btn
            large
            depressed
            max-height="40px"
            color="#fff"
            class="button-type-1"
            @click.stop="cancel"
          >
            취소
          </v-btn>
          <v-btn
            large
            depressed
            max-height="40px"
            color="#fecd06"
            class="button-type-1 ml-4"
            :disabled="!searchSelChoice || !searchSelChoice2"
            @click.prevent="updateAdvertiserInfo"
          >
            완료
          </v-btn>
        </div>
      </div>

      <SystemAlert v-model="showSystemAlert">
        <div slot="noti-text">{{ logResult }}</div>
        <div slot="noti-btns">
          <v-btn
            large
            depressed
            max-height="40px"
            min-width="104px"
            color="#fecd06"
            class="button-type-1"
            @click.stop="closePopup()"
          >
            확인
          </v-btn>
        </div>
      </SystemAlert>
      <SystemAlert v-model="confirmSystemAlert">
        <div slot="noti-text">{{ logResult }}</div>
        <div slot="noti-btns">
          <v-btn
            large
            depressed
            max-height="40px"
            min-width="104px"
            color="#fecd06"
            class="button-type-1"
            @click.stop="advertiserDisabe"
          >
            확인
          </v-btn>
          <v-btn
            large
            depressed
            max-height="40px"
            min-width="104px"
            color="#fff"
            class="button-type-1 ml-2"
            @click.stop="confirmSystemAlert = false"
          >
            취소
          </v-btn>
        </div>
      </SystemAlert>
    </div>
  </div>
</template>

<script>
import { detailAdvertiser, updateAdvertiser } from '@/api/advertiser';
import { sectors } from '@/api/etc';
import { constantAdvertiserType } from '@/utils/constant';
import bus from '@/utils/bus.js';
import SystemAlert from '~@/modal/SystemAlert.vue';
export default {
  components: { SystemAlert },
  data: () => ({
    confirmSystemAlert: false,
    showSystemAlert: false,
    logResult: '',
    //valid: false,

    advertiserinfoInfo: {},
    advertiserName: '',

    searchSel: ['광고주', '대행사', '내부광고'],
    searchSelChoice: '',

    searchSel2: [],
    searchSelChoice2: '',
    sectorsMap: {},

    managerName: '',
    advertiserEmail: '',
    eamilRules: [
      v => !!v || '이메일을 입력해주세요.',
      v => (v && /.+@.+\..+/.test(v)) || '이메일 형식을 지켜주세요.',
    ],
    creator: {},

    isValid: 'Y',

    resultType: '',

    //emailHintDisplay: true,
  }),
  methods: {
    async getAdvertiserinfo() {
      const id = this.$route.params.id;
      try {
        const { data } = await detailAdvertiser(id);
        //업종 리스트
        this.getSector();

        this.advertiserinfoInfo = data.row;
        this.advertiserName = data.row.name;
        this.searchSelChoice = constantAdvertiserType[data.row.type];

        this.searchSelChoice2 = data.row.sector.name;

        this.managerName = data.row.manager_name;
        this.advertiserEmail = data.row.email;
        this.creator = data.row.creator;

        bus.$emit('end:spinner');
      } catch (error) {
        bus.$emit('end:spinner');
        console.log(error.response);
      }
    },
    async getSector() {
      try {
        const { data } = await sectors();
        const list = data.list;
        const listMap = {};
        const names = [];
        (list || []).forEach(item => {
          listMap[item.name] = item;
          names.push(item.name);
        });
        this.sectorsMap = listMap;
        this.searchSel2 = names;
      } catch (error) {
        console.log(error.response);
      }
    },
    async updateAdvertiserInfo() {
      bus.$emit('start:spinner');
      const id = this.$route.params.id;
      try {
        const advertiserData = {
          type: this.getKeyByValue(
            constantAdvertiserType,
            this.searchSelChoice,
          ),
          name: this.advertiserName,
          email: this.advertiserEmail.trim(),
          manager_name: this.managerName.trim(),
          sector: {
            id: this.sectorsMap[this.searchSelChoice2].id,
          },
        };
        const { data } = await updateAdvertiser(id, advertiserData);
        this.resultType = data.result;
        if (data.result === 'success') {
          bus.$emit('end:spinner');
          this.showSystemAlert = true;
          this.logResult = '변경사항이 저장되었습니다.';
        }
      } catch (error) {
        bus.$emit('end:spinner');
        console.log(error.response);
        this.resultType = data.result;
        const { data } = error.response;
        if (data.result === 'DuplicatedEntry') {
          this.logResult = '이미 사용중인 회사명 입니다.';
        } else {
          this.logResult = '등록 중 에러가 발생했습니다. 재시도 부탁드립니다.';
        }
      }
    },
    getKeyByValue(object, value) {
      return Object.keys(object).find(key => object[key] === value);
    },
    closePopup() {
      const type = this.resultType;
      this.showSystemAlert = false;
      if (type === 'success') {
        this.$router.push({ name: 'partners' }).catch(() => {});
      }
    },
    cancel() {
      this.getAdvertiserinfo();
      this.$router.push({ name: 'partners' }).catch(() => {});
    },
    changeDisable() {
      this.confirmSystemAlert = true;
      this.logResult = `광고주를 정말 비활성화
하시겠습니까?
비활성화 후 해당 광고주는 캠페인 집행이 불가합니다.`;
    },
    async advertiserDisabe() {
      try {
        const id = this.$route.params.id;
        let advertiserData = {
          is_valid: 'N',
        };
        const { data } = await updateAdvertiser(id, advertiserData);
        if (data.result === 'success') {
          this.$router.push({ name: 'partners' }).catch(() => {});
        }
      } catch (error) {
        console.log(error.response);
      }
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    async hideHint(event) {
      if (event.target.value === '') {
        await this.$refs.form2.resetValidation();
      }
    },
  },
  created() {
    bus.$emit('start:spinner');
    this.getAdvertiserinfo();
  },
};
</script>

<style lang="scss" scoped></style>
